import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pontaj-shell" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = {
  key: 1,
  class: "zile-lbl"
}
const _hoisted_4 = {
  key: 2,
  class: "badge-blocat"
}
const _hoisted_5 = {
  key: 4,
  class: "status"
}
const _hoisted_6 = {
  key: 5,
  class: "status"
}
const _hoisted_7 = { class: "split" }
const _hoisted_8 = { class: "pane-left" }
const _hoisted_9 = { class: "pane-right" }
const _hoisted_10 = {
  key: 0,
  class: "emp-head"
}
const _hoisted_11 = {
  key: 1,
  class: "emp-head muted"
}
const _hoisted_12 = { class: "tab-title" }
const _hoisted_13 = { class: "tab-body" }
const _hoisted_14 = {
  key: 7,
  class: "placeholder"
}
const _hoisted_15 = { class: "popup-body" }
const _hoisted_16 = {
  key: 0,
  class: "form-row"
}
const _hoisted_17 = { class: "popup-actions" }
const _hoisted_18 = { class: "popup-body" }
const _hoisted_19 = { class: "popup-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxDropDownButton = _resolveComponent("DxDropDownButton")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_PontajIntroducere = _resolveComponent("PontajIntroducere")!
  const _component_PontajIstoric = _resolveComponent("PontajIstoric")!
  const _component_PontajProiecte = _resolveComponent("PontajProiecte")!
  const _component_GridCentreCost = _resolveComponent("GridCentreCost")!
  const _component_PontajComponentaSuma = _resolveComponent("PontajComponentaSuma")!
  const _component_PontajRepartizare = _resolveComponent("PontajRepartizare")!
  const _component_DxTabPanel = _resolveComponent("DxTabPanel")!
  const _component_DxSelectionGrid = _resolveComponent("DxSelectionGrid")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxFileUploader = _resolveComponent("DxFileUploader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DxButton, {
        icon: "save",
        text: "Salvează",
        type: "default",
        "styling-mode": "contained",
        onClick: _ctx.salveaza,
        disabled: _ctx.loading
      }, null, 8, ["onClick", "disabled"]),
      _createVNode(_component_DxButton, {
        icon: "close",
        text: "Închide",
        type: "normal",
        "styling-mode": "outlined",
        onClick: _ctx.inchide
      }, null, 8, ["onClick"]),
      _createVNode(_component_DxButton, {
        icon: "find",
        text: "Încarcă",
        type: "default",
        "styling-mode": "contained",
        onClick: _ctx.incarca,
        disabled: _ctx.loading
      }, null, 8, ["onClick", "disabled"]),
      _createVNode(_component_DxDropDownButton, {
        text: "Pontaj",
        icon: "bulletlist",
        "styling-mode": "outlined",
        items: _ctx.pontajMenuItems,
        "display-expr": "text",
        "key-expr": "id",
        "drop-down-options": { width: 280 },
        onItemClick: _ctx.onPontajMenuClick,
        disabled: _ctx.loading
      }, null, 8, ["items", "onItemClick", "disabled"]),
      (_ctx.drepturi.CentreCost)
        ? (_openBlock(), _createBlock(_component_DxDropDownButton, {
            key: 0,
            text: "Centre de Cost",
            icon: "money",
            "styling-mode": "outlined",
            items: _ctx.centreCostMenuItems,
            "display-expr": "text",
            "key-expr": "id",
            "drop-down-options": { width: 280 },
            onItemClick: _ctx.onCentreCostMenuClick,
            disabled: _ctx.loading
          }, null, 8, ["items", "onItemClick", "disabled"]))
        : _createCommentVNode("", true),
      _createVNode(_component_DxButton, {
        icon: "exportpdf",
        text: "Raport angajați vizibili",
        type: "normal",
        "styling-mode": "outlined",
        onClick: _ctx.raportAngajatiVizibili,
        disabled: _ctx.loading
      }, null, 8, ["onClick", "disabled"]),
      _createVNode(_component_DxSelectBox, {
        items: _ctx.luni,
        "display-expr": "text",
        "value-expr": "value",
        value: _ctx.lunaSel,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.lunaSel) = $event)),
        width: 140,
        label: "Luna",
        "label-mode": "floating"
      }, null, 8, ["items", "value"]),
      _createVNode(_component_DxNumberBox, {
        value: _ctx.anSel,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.anSel) = $event)),
        width: 90,
        min: 2000,
        max: 2100,
        label: "An",
        "label-mode": "floating",
        "show-spin-buttons": true
      }, null, 8, ["value"]),
      _createVNode(_component_DxCheckBox, {
        value: _ctx.concedii,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.concedii) = $event)),
        text: "Concedii medicale"
      }, null, 8, ["value"]),
      (_ctx.zileLucr.Zile)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _cache[11] || (_cache[11] = _createTextVNode("Zile lucrătoare: ", -1)),
            _createElementVNode("b", null, _toDisplayString(_ctx.zileLucr.Zile), 1),
            _cache[12] || (_cache[12] = _createTextVNode(" · Ore: ", -1)),
            _createElementVNode("b", null, _toDisplayString(_ctx.zileLucr.Ore), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.blocata)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [...(_cache[13] || (_cache[13] = [
            _createElementVNode("i", { class: "dx-icon-lock" }, null, -1),
            _createTextVNode(" Lună blocată", -1)
          ]))]))
        : _createCommentVNode("", true),
      (_ctx.blocata)
        ? (_openBlock(), _createBlock(_component_DxButton, {
            key: 3,
            icon: "unlock",
            text: "Deschide luna",
            type: "danger",
            "styling-mode": "outlined",
            onClick: _ctx.deschideLuna,
            disabled: _ctx.loading
          }, null, 8, ["onClick", "disabled"]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Se încarcă…"))
        : (_ctx.loadingPontaj)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Se încarcă pontajul…"))
          : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_DxDataGrid, {
          "data-source": _ctx.angajati,
          "key-expr": "Id",
          "show-borders": true,
          height: "100%",
          "focused-row-enabled": true,
          "auto-navigate-to-focused-row": true,
          "focused-row-key": _ctx.empIdSel,
          "onUpdate:focusedRowKey": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.empIdSel) = $event)),
          "hover-state-enabled": true,
          "row-alternation-enabled": true,
          onContextMenuPreparing: _ctx.onEmpContextMenu
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxScrolling, { mode: "virtual" }),
            _createVNode(_component_DxSearchPanel, {
              visible: true,
              width: 200,
              placeholder: "Caută angajat…"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "InternalCode",
              caption: "Marca",
              width: 70
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "NumePrenume",
              caption: "Nume"
            }),
            _createVNode(_component_DxColumn, {
              "data-field": "Departament",
              caption: "Departament",
              width: 130,
              visible: false
            })
          ]),
          _: 1
        }, 8, ["data-source", "focused-row-key", "onContextMenuPreparing"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_ctx.empSelNume)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.empSelMarca) + " · " + _toDisplayString(_ctx.empSelNume), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, "Selectează un angajat din stânga. (F7/F8 pentru navigare)")),
        _createVNode(_component_DxTabPanel, {
          "data-source": _ctx.tabs,
          "selected-index": _ctx.selectedIndex,
          "swipe-enabled": false,
          "item-title-template": "title",
          onOptionChanged: _ctx.onTabChanged,
          class: "tabs"
        }, {
          title: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_12, _toDisplayString(data.text), 1)
          ]),
          item: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_13, [
              (data.key === 'introducere')
                ? (_openBlock(), _createBlock(_component_PontajIntroducere, {
                    key: 0,
                    "zile-rows": _ctx.zileRows,
                    blocata: _ctx.blocata,
                    "coduri-map": _ctx.coduriMap,
                    "emp-label": _ctx.empLabel,
                    onRefresh: _ctx.incarca
                  }, null, 8, ["zile-rows", "blocata", "coduri-map", "emp-label", "onRefresh"]))
                : (data.key === 'istoric')
                  ? (_openBlock(), _createBlock(_component_PontajIstoric, {
                      key: 1,
                      "emp-id": _ctx.empIdSel,
                      an: _ctx.anSel,
                      luna: _ctx.lunaSel
                    }, null, 8, ["emp-id", "an", "luna"]))
                  : (data.key === 'istcomplet')
                    ? (_openBlock(), _createBlock(_component_PontajIstoric, {
                        key: 2,
                        "emp-id": _ctx.empIdSel,
                        an: _ctx.anSel,
                        luna: _ctx.lunaSel,
                        complet: true
                      }, null, 8, ["emp-id", "an", "luna"]))
                    : (data.key === 'proiecte')
                      ? (_openBlock(), _createBlock(_component_PontajProiecte, {
                          key: 3,
                          "emp-id": _ctx.empIdSel,
                          "luna-sel": _ctx.lunaSel,
                          "an-sel": _ctx.anSel
                        }, null, 8, ["emp-id", "luna-sel", "an-sel"]))
                      : (data.key === 'capconfig' && _ctx.empIdSel)
                        ? (_openBlock(), _createBlock(_component_GridCentreCost, {
                            "employee-id": _ctx.empIdSel,
                            key: 'cc-' + _ctx.empIdSel
                          }, null, 8, ["employee-id"]))
                        : (data.key === 'capsuma')
                          ? (_openBlock(), _createBlock(_component_PontajComponentaSuma, {
                              key: 5,
                              "emp-id": _ctx.empIdSel,
                              angajati: _ctx.angajati
                            }, null, 8, ["emp-id", "angajati"]))
                          : (data.key === 'caprepart')
                            ? (_openBlock(), _createBlock(_component_PontajRepartizare, {
                                key: 6,
                                "emp-id": _ctx.empIdSel,
                                "luna-sel": _ctx.lunaSel,
                                "an-sel": _ctx.anSel,
                                onRefresh: _ctx.incarca
                              }, null, 8, ["emp-id", "luna-sel", "an-sel", "onRefresh"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _cache[14] || (_cache[14] = _createElementVNode("i", {
                                  class: "dx-icon-clock",
                                  style: {"font-size":"32px","opacity":".4"}
                                }, null, -1)),
                                _createElementVNode("p", null, _toDisplayString(data.text) + " — în lucru.", 1)
                              ]))
            ])
          ]),
          _: 1
        }, 8, ["data-source", "selected-index", "onOptionChanged"])
      ])
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "legenda" }, [
      _createElementVNode("b", null, "Legendă:"),
      _createTextVNode(" 0-24 = ore · X = nelucrătoare · CM = concediu medical · CO = concediu odihnă · CFP = fără plată · N = nemotivat · DET = detașare · DLG = delegație. ")
    ], -1)),
    _createVNode(_component_DxPopup, {
      visible: _ctx.popupMultiVisible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.popupMultiVisible) = $event)),
      title: _ctx.popupMultiTitle,
      width: 520,
      height: 560,
      "show-close-button": true,
      "drag-enabled": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          (_ctx.popupMultiMode.startsWith('configurare'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_DxSelectBox, {
                  "data-source": _ctx.dsCapitole,
                  "value-expr": "Id",
                  "display-expr": _ctx.capDisplay,
                  value: _ctx.popupCapitolId,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.popupCapitolId) = $event)),
                  label: "Centru de cost",
                  "label-mode": "floating",
                  "search-enabled": true
                }, null, 8, ["data-source", "display-expr", "value"]),
                _createVNode(_component_DxSelectBox, {
                  "data-source": _ctx.dsConturi,
                  "value-expr": "Id",
                  "display-expr": _ctx.contDisplay,
                  value: _ctx.popupContId,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.popupContId) = $event)),
                  label: "Cont contabil (opțional)",
                  "label-mode": "floating",
                  "search-enabled": true,
                  "show-clear-button": true
                }, null, 8, ["data-source", "display-expr", "value"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.popupMultiMode !== 'configurareToti')
            ? (_openBlock(), _createBlock(_component_DxDataGrid, {
                key: 1,
                "data-source": _ctx.angajati,
                "key-expr": "Id",
                height: "380",
                "show-borders": true,
                "hover-state-enabled": true,
                onSelectionChanged: _ctx.onPopupSelectionChanged,
                "selected-row-keys": _ctx.popupSelectedKeys
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxSelectionGrid, {
                    mode: "multiple",
                    "show-check-boxes-mode": "always"
                  }),
                  _createVNode(_component_DxScrolling, { mode: "virtual" }),
                  _createVNode(_component_DxSearchPanel, {
                    visible: true,
                    placeholder: "Caută angajat…"
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "InternalCode",
                    caption: "Marca",
                    width: 70
                  }),
                  _createVNode(_component_DxColumn, {
                    "data-field": "NumePrenume",
                    caption: "Nume"
                  })
                ]),
                _: 1
              }, 8, ["data-source", "onSelectionChanged", "selected-row-keys"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_DxButton, {
              text: "Anulează",
              "styling-mode": "outlined",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.popupMultiVisible = false))
            }),
            _createVNode(_component_DxButton, {
              text: "Confirmă",
              type: "default",
              "styling-mode": "contained",
              onClick: _ctx.confirmPopupMulti,
              disabled: (_ctx.popupMultiMode !== 'configurareToti' && !_ctx.popupSelectedKeys.length) || (_ctx.popupMultiMode.startsWith('configurare') && !_ctx.popupCapitolId)
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.popupUploadVisible,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.popupUploadVisible) = $event)),
      title: "Import pontaj din fișier (XLSX)",
      width: 440,
      height: 260,
      "show-close-button": true,
      "drag-enabled": true
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_DxFileUploader, {
            "select-button-text": "Selectează fișier",
            accept: ".xlsx",
            "upload-mode": "useForm",
            multiple: false,
            onValueChanged: _ctx.onUploadFileChanged
          }, null, 8, ["onValueChanged"]),
          _createVNode(_component_DxCheckBox, {
            value: _ctx.uploadTranspus,
            "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.uploadTranspus) = $event)),
            text: "Este transpus"
          }, null, 8, ["value"]),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_DxButton, {
              text: "Anulează",
              "styling-mode": "outlined",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.popupUploadVisible = false))
            }),
            _createVNode(_component_DxButton, {
              text: "Încarcă",
              type: "default",
              "styling-mode": "contained",
              onClick: _ctx.confirmUploadXlsx,
              disabled: !_ctx.uploadFile
            }, null, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}